const regionData = [
  {
    value: 'United States',
    children: [
      {
        value: 'California',
        children: [
          { value: 'San Francisco' },
          { value: 'Los Angeles' },
          { value: 'San Diego' },
          { value: 'Sacramento' }
        ]
      },
      {
        value: 'Texas',
        children: [
          { value: 'Austin' },
          { value: 'Dallas' },
          { value: 'Houston' },
          { value: 'San Antonio' }
        ]
      },
      {
        value: 'Florida',
        children: [
          { value: 'Miami' },
          { value: 'Orlando' },
          { value: 'Tampa' },
          { value: 'Jacksonville' }
        ]
      },
      {
        value: 'New York',
        children: [
          { value: 'New York City' },
          { value: 'Buffalo' },
          { value: 'Rochester' },
          { value: 'Albany' }
        ]
      }
    ]
  },
  {
    value: 'Canada',
    children: [
      {
        value: 'Ontario',
        children: [
          { value: 'Toronto' },
          { value: 'Ottawa' },
          { value: 'Hamilton' },
          { value: 'London' }
        ]
      },
      {
        value: 'Quebec',
        children: [
          { value: 'Montreal' },
          { value: 'Quebec City' },
          { value: 'Laval' },
          { value: 'Gatineau' }
        ]
      },
      {
        value: 'British Columbia',
        children: [
          { value: 'Vancouver' },
          { value: 'Victoria' },
          { value: 'Kelowna' },
          { value: 'Surrey' }
        ]
      },
      {
        value: 'Alberta',
        children: [
          { value: 'Calgary' },
          { value: 'Edmonton' },
          { value: 'Red Deer' },
          { value: 'Lethbridge' }
        ]
      }
    ]
  },
  {
    value: 'United Kingdom',
    children: [
      {
        value: 'England',
        children: [
          { value: 'London' },
          { value: 'Manchester' },
          { value: 'Birmingham' },
          { value: 'Liverpool' }
        ]
      },
      {
        value: 'Scotland',
        children: [
          { value: 'Edinburgh' },
          { value: 'Glasgow' },
          { value: 'Aberdeen' },
          { value: 'Dundee' }
        ]
      },
      {
        value: 'Wales',
        children: [
          { value: 'Cardiff' },
          { value: 'Swansea' },
          { value: 'Newport' },
          { value: 'Wrexham' }
        ]
      },
      {
        value: 'Northern Ireland',
        children: [
          { value: 'Belfast' },
          { value: 'Derry' },
          { value: 'Lisburn' },
          { value: 'Newry' }
        ]
      }
    ]
  },
  {
    value: 'Germany',
    children: [
      {
        value: 'Bavaria',
        children: [
          { value: 'Munich' },
          { value: 'Nuremberg' },
          { value: 'Augsburg' },
          { value: 'Wurzburg' }
        ]
      },
      {
        value: 'Hesse',
        children: [
          { value: 'Frankfurt' },
          { value: 'Wiesbaden' },
          { value: 'Darmstadt' },
          { value: 'Kassel' }
        ]
      },
      {
        value: 'Berlin',
        children: [
          { value: 'Mitte' },
          { value: 'Friedrichshain' },
          { value: 'Charlottenburg' },
          { value: 'Spandau' }
        ]
      },
      {
        value: 'Hamburg',
        children: [
          { value: 'Altona' },
          { value: 'Eimsbuttel' },
          { value: 'Wandsbek' },
          { value: 'Bergedorf' }
        ]
      }
    ]
  },
  {
    value: 'Japan',
    children: [
      {
        value: 'Tokyo',
        children: [
          { value: 'Shinjuku' },
          { value: 'Shibuya' },
          { value: 'Minato' },
          { value: 'Setagaya' }
        ]
      },
      {
        value: 'Osaka',
        children: [
          { value: 'Kita' },
          { value: 'Naniwa' },
          { value: 'Tennoji' },
          { value: 'Abeno' }
        ]
      },
      {
        value: 'Kanagawa',
        children: [
          { value: 'Yokohama' },
          { value: 'Kawasaki' },
          { value: 'Yokosuka' },
          { value: 'Kamakura' }
        ]
      },
      {
        value: 'Hokkaido',
        children: [
          { value: 'Sapporo' },
          { value: 'Hakodate' },
          { value: 'Asahikawa' },
          { value: 'Otaru' }
        ]
      }
    ]
  },
  {
    value: 'Australia',
    children: [
      {
        value: 'New South Wales',
        children: [
          { value: 'Sydney' },
          { value: 'Newcastle' },
          { value: 'Wollongong' },
          { value: 'Parramatta' }
        ]
      },
      {
        value: 'Victoria',
        children: [
          { value: 'Melbourne' },
          { value: 'Geelong' },
          { value: 'Ballarat' },
          { value: 'Bendigo' }
        ]
      },
      {
        value: 'Queensland',
        children: [
          { value: 'Brisbane' },
          { value: 'Gold Coast' },
          { value: 'Cairns' },
          { value: 'Townsville' }
        ]
      },
      {
        value: 'Western Australia',
        children: [
          { value: 'Perth' },
          { value: 'Fremantle' },
          { value: 'Bunbury' },
          { value: 'Albany' }
        ]
      }
    ]
  }
]

export default regionData
